import React from 'react'

//styles
import ProductClientView from '../../components/productClientView/ProductClientView'

const Products = () => {
  return (
    <div>
        <ProductClientView />
    </div>
  )
}

export default Products